/**
 * Read model loader for the Workable Site app.
 *
 * IMPORTANT: This is the ONLY file in apps/workable-site that imports
 * from framework/generated/editions/. No other source file in this app
 * may import from framework/, framework/content, framework/partners,
 * accenture-*.snapshot.json, or @apf/framework-config.
 */

import type { EditionReadModel } from "@apf/site-publication";
import type { EditionId } from "./edition.ts";

// Written by editions:publish from admitted WorldService pins. While pins.json
// is empty these are committed "awaiting-admission" placeholders. With
// WORKABLE_EDITIONS=dev, vite.config.ts swaps in local development previews.
import coreModel from "../../../framework/generated/editions/core.public.json";
import accentureModel from "../../../framework/generated/editions/accenture.public.json";

export type AwaitingModel = {
  schemaVersion: "workable.site-publication/1";
  edition: EditionId;
  status: "awaiting-admission";
  sources: [];
};

export type SiteModel = EditionReadModel | AwaitingModel;
export type SiteModels = Record<EditionId, SiteModel>;

export function isAwaiting(model: SiteModel): model is AwaitingModel {
  return (model as AwaitingModel).status === "awaiting-admission";
}

export const publishedModels: SiteModels = {
  core: coreModel as unknown as SiteModel,
  accenture: accentureModel as unknown as SiteModel,
};

export function readModelFor(edition: EditionId, models: SiteModels = publishedModels): SiteModel {
  return models[edition];
}
